import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { searchBox, hits, stats, pagination, refinementList, clearRefinements, currentRefinements, configure } from 'instantsearch.js/es/widgets';

if (window.ALGOLIA_APP_ID && window.ALGOLIA_KEY && window.ALGOLIA_INDEX) {
    const searchClient = algoliasearch(window.ALGOLIA_APP_ID, window.ALGOLIA_KEY);



    const search = instantsearch({
        indexName: window.ALGOLIA_INDEX,
        searchClient,
        routing: true,
    });

    search.templatesConfig.helpers.dateFormat = function (date, render) {
        // console.log(render(date));
        return (new Date(render(date)).toLocaleDateString("en-US", {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        }));
    };


    function SetDisplayPay(max, min) {
        // console.log(max, min);

        if (min && max && (max > min)) {
            return '$' + min + ' — $' + max + '/hr';
        } else if (min) {
            return '$' + min + '/hr';
        } else if (max) {
            return '$' + max + '/hr';
        } else {
            return '—';
        }
    }


    search.addWidgets([
        configure({
            aroundLatLngViaIP: true,
        }),
        searchBox({
            container: '#searchbox',
            showSubmit: false,
            showLoadingIndicator: true,
            placeholder: 'Job Details, Location, ZIP',
            autofocus: false,
            cssClasses: {
                input: 'form-control input-dark',
            }
        }),

        clearRefinements({
            container: '#clearRefinements',
            cssClasses: {
                button: 'btn btn-primary btn-blue-light',
            }
        }),

        currentRefinements({
            container: '#currentRefinements'
        }),

        stats({
            container: '#jobStats',
            templates: {
                text: `
            {{#hasNoResults}}No Available Jobs{{/hasNoResults}}
            {{#hasOneResult}}1 Available Job{{/hasOneResult}}
            {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} Available Jobs{{/hasManyResults}}
            `,
            }
        }),

        // refinementList({
        //     container: '#EmploymentTypeRefinement',
        //     attribute: 'Employment Type',
        // }),
        // refinementList({
        //     container: '#IndustryRefinement',
        //     attribute: 'Industry',
        // }),
        refinementList({
            container: '#ExperienceRefinement',
            attribute: 'Experience Level',
        }),
        refinementList({
            container: '#HoursRefinement',
            attribute: 'Work Hours',
        }),
        refinementList({
            container: '#PerksRefinement',
            attribute: 'Perks',
        }),

        pagination({
            container: '#job-pagination',
        }),

        hits({
            container: '#job-hits',
            transformItems(items) {
                return items.map(item => ({
                    ...item,
                    // name: item.name.toUpperCase(),
                    "Maximum Pay": SetDisplayPay(item['Maximum Pay'], item['Minimum Pay']),
                }));
            },
            templates: {
                item: `
            <article class="card-jobs">
            <div class="row row-grid justify-content-xl-between">
                <div class="col-sm-5 col-md-6 col-xl-4 col-xxl-5">
                    <h3 class="card-title">
                        {{ Title }}
                    </h3>
                    <span class="item-location">
                        {{ City }}, {{ State }}
                    </span>
                    <span class="text-sm">
                        Posted: {{#helpers.dateFormat}}{{Date Posted}}{{/helpers.dateFormat}}{{  }}
                    </span>
                </div>
                <div class="col-sm-7 col-md-6 col-xl-5 col-xxl-4">
                    <div class="row row-grid">
                        <div class="col-6">
                            <strong class="micro-title color-orange-dark mb-2">
                                Pay Rate
                            </strong>
                            <p>
                            {{ Maximum Pay }}
                            </p>
                        </div>
                        {{#Work Hours}}
                            <div class="col-6">
                                <strong class="micro-title color-orange-dark mb-2">
                                    Work Hours
                                </strong>
                                <p>
                                    {{Work Hours}}
                                </p>
                            </div>
                        {{/Work Hours}}
                    </div>
                </div>
                <div class="col-xl-auto">
                    <a href="{{URL}}" class="btn btn-primary btn-orange btn-xs-block">
                        View Job
                    </a>
                </div>
            </div>
        </article>
            `,
            },
        }),


    ]);

    search.start();
    // $('#initial-jobs').html('');

}

